import * as React from "react";
import { observer } from "mobx-react";
import { HotelWizardStateProps } from "../typings";
import { HotelRatesType } from "stores/wizard/state/typings";

export const HotelHiddenSearchData = observer((props: HotelWizardStateProps) => {
  const {
    isAddACarChecked,
    isAddAFlightChecked,
    hotelTypeSubTab,
    hotelPackageType,
    hotelTabSelected,
    sourceIdSelected,
    latLong,
    config,
    regionId,
    hotelRegionId,
  } = props.hotelWizardState;

  return (
    <>
      {hotelTypeSubTab !== HotelRatesType.PACKAGE_RATES && (isAddAFlightChecked || isAddACarChecked) && (
        <input type="hidden" name="packageType" data-testid="package-type" value={hotelPackageType} />
      )}
      {regionId && <input type="hidden" name="regionId" data-testid="regionId" value={hotelRegionId} />}
      {!hotelTabSelected && <input type="hidden" name="sort" data-testid="vr-sort" value="vacationRental" />}
      {sourceIdSelected && <input type="hidden" name="selected" data-testid="source-id" value={sourceIdSelected} />}
      {latLong && <input type="hidden" name="latLong" data-testid="lat-long" value={latLong} />}
      {config.hotelChainID && (
        <input type="hidden" name="chain" data-testid="hotel-chain" value={config.hotelChainID} />
      )}
      {config.hotelName && <input type="hidden" name="hotelName" data-testid="hotel-name" value={config.hotelName} />}
      {config.hotelID && <input type="hidden" name="group" data-testid="hotel-group" value={config.hotelID} />}
    </>
  );
});
